// Constants
// Slices
import { UpdatableSlice } from "./UpdatableSlice";
/**
 * Enhanced slice implementation for diffable types T that extends IDiffable<T> and IEntity.
 * Extends the basic Slice with update and baseline functionality.
 * Uses EntityTable instead of BasicTable for diffing support.
 */ export class EntitySlice extends UpdatableSlice {
    constructor(name, indexDefinitions, configProvider){
        super(name, indexDefinitions, (a, b)=>a.version < b.version, configProvider);
    }
}
